import { TitleBar } from "./title-bar";
import { titleBarStyles as styles } from "./title-bar.styles";
import { titleBarTemplate as template } from "./title-bar.template";
/* eslint-disable sort-keys */
export const widgetTitleBar = TitleBar.compose({
    baseName: "widget-title-bar",
    template,
    styles,
});
